<div class="wrapper">
  <div class="content">
    <svg
      width="418"
      height="418"
      viewBox="0 0 418 418"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_823_2791)">
        <path
          d="M162.96 335.605C162.166 342.789 156.246 348.58 149.049 349.238C146.495 349.474 143.922 349.071 141.563 348.065V374.807H223.491V292.879H203.202C202.04 292.879 200.925 293.34 200.104 294.162C199.282 294.983 198.821 296.098 198.821 297.26C198.821 299.806 199.801 302.307 201.694 304.007C203.312 305.455 204.606 307.228 205.491 309.21C206.376 311.193 206.832 313.34 206.83 315.511C206.83 324.631 198.934 331.906 189.605 330.876C182.421 330.082 176.629 324.162 175.972 316.965C175.745 314.583 176.076 312.18 176.938 309.947C177.8 307.714 179.169 305.713 180.938 304.1C181.881 303.23 182.633 302.173 183.146 300.996C183.658 299.82 183.92 298.549 183.915 297.266V297.26C183.915 296.098 183.453 294.983 182.632 294.162C181.81 293.34 180.696 292.879 179.534 292.879H141.561V319.619C143.468 318.803 145.52 318.382 147.594 318.38C156.716 318.38 163.991 326.276 162.96 335.605Z"
          fill="#E4E4E4" />
      </g>
      <g clip-path="url(#clip1_823_2791)">
        <path
          d="M149.991 360.117L137.313 368.224L70.9856 269.219L84.9298 233.375L149.991 360.117Z"
          fill="#222222" />
        <path
          d="M73.8983 132.398L72.0706 149.035L83.9485 146.478L79.6419 129.398L73.8983 132.398Z"
          fill="#939498" />
        <path
          d="M76.4014 113.454C70.4564 113.891 68.1259 116.192 69.6758 124.057C71.0121 130.84 75.7768 131.621 75.7768 131.621C77.1087 134.232 79.0831 136.462 81.5142 138.1C83.9453 139.738 86.7531 140.73 89.6732 140.983C89.6732 140.983 89.1962 138.37 88.608 135.136C87.6954 135.095 86.8051 134.84 86.0084 134.393C85.2118 133.946 84.5307 133.319 84.0197 132.561C85.345 133.112 86.8064 133.248 88.2105 132.95C87.42 128.599 86.5773 123.942 86.4403 123.109C85.0411 114.594 80.1863 113.175 76.4014 113.454Z"
          fill="#DBD8D3" />
        <path
          d="M170.957 178.006C175.345 178.006 178.902 174.448 178.902 170.059C178.902 165.669 175.345 162.111 170.957 162.111C166.569 162.111 163.012 165.669 163.012 170.059C163.012 174.448 166.569 178.006 170.957 178.006Z"
          fill="#222222" />
        <path
          d="M63.8352 170.352C63.8352 170.352 60.4849 187.335 76.9571 195.752C102.73 208.92 131.101 196.227 131.105 196.226L63.8352 170.352Z"
          fill="#222222" />
        <path
          d="M166.186 175.648L164.58 170.218C159.236 170.351 125.063 178.304 118.79 191.489L131.105 196.226L165.82 175.554L166.186 175.648Z"
          fill="#222222" />
        <path
          d="M68.0048 154.796L70.0627 147.681L86.416 144.7L85.7649 156.063L68.0048 154.796Z"
          fill="#CBA660" />
        <path
          d="M85.9125 153.016C85.9125 153.016 60.8968 148.32 52.9771 170.329C42.3969 199.724 61.236 233.375 61.236 233.375H85.01L85.9125 153.016Z"
          fill="#434343" />
        <path d="M84.7125 117.787L91.0656 129.341L86.3085 129.68L84.7125 117.787Z" fill="#DBD8D3" />
        <path
          d="M84.2143 116.795C82.9675 114.893 81.0691 113.511 78.8759 112.911C76.6827 112.311 74.3458 112.532 72.3044 113.534C70.2631 114.536 68.658 116.25 67.7908 118.352C66.9236 120.455 66.854 122.802 67.5951 124.953C67.9938 126.083 68.6186 127.12 69.4312 128.001C70.2439 128.882 71.2275 129.588 72.3219 130.076C72.3219 130.076 78.8666 128.821 78.2783 119.371C80.425 119.092 82.4567 118.24 84.1598 116.903C84.1916 116.878 84.1946 116.83 84.2143 116.795Z"
          fill="#222222" />
        <path
          d="M73.5356 133.702C75.7055 133.702 77.4644 131.942 77.4644 129.772C77.4644 127.601 75.7055 125.842 73.5356 125.842C71.3658 125.842 69.6069 127.601 69.6069 129.772C69.6069 131.942 71.3658 133.702 73.5356 133.702Z"
          fill="#DBD8D3" />
        <path
          d="M81.5416 123.133L84.3915 122.913L84.4619 123.825L81.612 124.045L81.5416 123.133Z"
          fill="#222222" />
        <path
          d="M133.649 165.719C132.572 167.628 114.887 179.974 109.001 199.271L121.692 205.882L139.114 166.125L133.649 165.719Z"
          fill="#DBD8D3" />
        <path
          d="M62.8524 164.25C62.8524 164.25 55.428 179.887 69.3237 192.099C91.0671 211.205 121.688 205.883 121.692 205.883L62.8524 164.25Z"
          fill="#CBA660" />
        <path
          d="M138.086 167.881C142.474 167.881 146.031 164.323 146.031 159.934C146.031 155.544 142.474 151.986 138.086 151.986C133.698 151.986 130.141 155.544 130.141 159.934C130.141 164.323 133.698 167.881 138.086 167.881Z"
          fill="#DBD8D3" />
        <path
          d="M137.313 368.224L141.519 374.806L172.381 354.351L149.991 360.117L137.313 368.224Z"
          fill="#434343" />
        <path
          d="M84.9298 233.375L87.0013 318.336L22.2245 367.07H7.52399C7.52399 367.07 35.3563 313.026 66.788 308.532C66.788 308.532 43.1715 255.637 60.8317 233.375H84.9298Z"
          fill="#CBA660" />
        <path d="M7.52399 367.07V374.806H43.1518L22.2245 367.07H7.52399Z" fill="#434343" />
        <path
          d="M60.8892 233.375H84.9298"
          stroke="#222222"
          stroke-width="5.43492"
          stroke-miterlimit="10" />
      </g>
      <g clip-path="url(#clip2_823_2791)">
        <path
          d="M175.458 86.4978C174.495 85.2828 172.839 84.87 171.481 85.6257L148.011 98.6843L167.855 134.349C168.463 135.441 168.61 136.729 168.266 137.931C167.922 139.133 167.114 140.15 166.021 140.759L166.015 140.762C163.573 142.121 160.672 142.428 158.025 141.546C155.583 140.729 152.983 140.492 150.431 140.852C147.878 141.212 145.444 142.159 143.319 143.62C136.886 148.008 134.341 156.548 137.348 163.711C141.252 173.014 152.229 176.618 160.813 171.842C165.115 169.448 167.942 165.436 168.958 160.993C169.57 158.322 171.412 156.094 173.809 154.76C174.903 154.151 176.193 154.001 177.396 154.342C178.599 154.684 179.615 155.489 180.223 156.58L190.825 175.635L267.952 132.721L225.137 55.7717L205.544 66.6729C204.186 67.4286 203.664 69.0532 204.189 70.5122C206.901 78.0408 203.828 86.6471 196.593 90.6725C189.357 94.6986 180.426 92.7713 175.458 86.4978Z"
          fill="#CBA660" />
      </g>
      <g clip-path="url(#clip3_823_2791)">
        <path
          d="M309.734 107.635V116.853H265.277V107.635H309.734ZM309.734 162.98V172.199H265.277V162.98H309.734ZM309.734 218.326V227.545H265.277V218.326H309.734ZM309.734 273.672V282.891H265.277V273.672H309.734ZM309.734 329.018V338.237H265.277V329.018H309.734ZM309.734 384.364V393.582H265.277V384.364H309.734Z"
          fill="#CBA660" />
        <path
          d="M309.734 135.309V144.526H265.277V135.309H309.734ZM309.733 190.654V199.873H265.276V190.654H309.733ZM309.734 246V255.218H265.277V246H309.734ZM309.733 301.346V310.564H265.276V301.346H309.733ZM309.734 356.691V365.91H265.277V356.691H309.734ZM309.733 412.038V421.256H265.276V412.038H309.733Z"
          fill="#222222" />
        <path
          d="M261.389 84.7148H270.595V446.982H261.389V84.7148ZM305.13 84.7148H314.336V446.982H305.13V84.7148Z"
          fill="#E4E4E4" />
      </g>
      <g clip-path="url(#clip4_823_2791)">
        <path
          d="M291.329 294.902L305.629 294.82L307.272 181.531L277.61 160.131L291.329 294.902Z"
          fill="#222222" />
        <path
          d="M234.155 73.8456L244.22 86.1776L233.429 90.2762L228.025 74.4198L234.155 73.8456Z"
          fill="#939498" />
        <path
          d="M222.357 60.0206C227.323 57.2975 230.371 57.9294 233.205 65.007C235.65 71.111 232.255 74.196 232.255 74.196C232.545 76.9687 232.125 79.7687 231.035 82.3323C229.945 84.8959 228.22 87.1388 226.023 88.8499C226.023 88.8499 225.051 86.518 223.847 83.633C224.553 83.1283 225.131 82.4651 225.534 81.6966C225.938 80.928 226.156 80.0753 226.172 79.2067C225.4 80.3315 224.306 81.1949 223.032 81.6826C221.411 77.8015 219.673 73.6499 219.351 72.9142C216.061 65.3953 219.196 61.7542 222.357 60.0206Z"
          fill="#DBD8D3" />
        <path
          d="M250.442 88.6744L245.12 84.0592L230.542 90.1322L236.941 98.8642L250.442 88.6744Z"
          fill="#CBA660" />
        <path
          d="M235.247 96.5086C235.247 96.5086 252.757 79.8327 270.458 93.3043C294.101 111.295 296.496 147.886 296.496 147.886L277.546 160.173L235.247 96.5086Z"
          fill="#434343" />
        <path
          d="M217.975 67.7734L218.889 80.2776L222.856 78.0899L217.975 67.7734Z"
          fill="#DBD8D3" />
        <path
          d="M217.859 66.7245C217.868 64.5621 218.667 62.4787 220.105 60.8661C221.542 59.2535 223.519 58.2227 225.665 57.9674C227.811 57.7121 229.977 58.2499 231.756 59.4798C233.535 60.7097 234.805 62.5469 235.327 64.6461C235.594 65.7543 235.633 66.905 235.441 68.028C235.249 69.151 234.83 70.2228 234.21 71.178C234.21 71.178 228.344 73.5587 223.924 65.7131C222.068 66.5998 220.007 66.9693 217.958 66.7827C217.92 66.7792 217.893 66.7427 217.859 66.7245Z"
          fill="#222222" />
        <path
          d="M235.119 74.6988C233.39 75.8202 231.077 75.325 229.954 73.5928C228.831 71.8606 229.322 69.5473 231.052 68.4259C232.782 67.3046 235.094 67.7997 236.217 69.532C237.34 71.2642 236.849 73.5775 235.119 74.6988Z"
          fill="#DBD8D3" />
        <path
          d="M223.269 70.4019L220.883 71.6994L221.299 72.4635L223.684 71.166L223.269 70.4019Z"
          fill="#222222" />
        <path
          d="M203.768 131.317C205.615 132.284 226.1 132.996 240.777 145.355L234.081 157.189L199.622 134.465L203.768 131.317Z"
          fill="#DBD8D3" />
        <path
          d="M259.441 93.5562C259.441 93.5562 273.45 102.198 268.692 119.125C261.246 145.61 234.085 157.188 234.082 157.19L259.441 93.5562Z"
          fill="#CBA660" />
        <path
          d="M201.351 135.336C197.854 137.603 193.177 136.602 190.906 133.099C188.635 129.596 189.629 124.918 193.127 122.651C196.624 120.383 201.3 121.385 203.572 124.887C205.843 128.39 204.848 133.068 201.351 135.336Z"
          fill="#DBD8D3" />
        <path
          d="M305.629 294.821L305.683 302.247L270.498 301.873L291.329 294.903L305.629 294.821Z"
          fill="#434343" />
        <path
          d="M277.61 160.132L319.919 229.006L396.77 234.422L408.487 226.824C408.487 226.824 358.338 198.078 330.959 210.735C330.959 210.735 322.414 156.317 296.818 147.678L277.61 160.132Z"
          fill="#CBA660" />
        <path
          d="M408.487 226.824L412.49 232.998L384.091 251.411L396.77 234.422L408.487 226.824Z"
          fill="#434343" />
        <path
          d="M296.773 147.707L277.61 160.131"
          stroke="#222222"
          stroke-width="5.16614"
          stroke-miterlimit="10" />
      </g>
      <g clip-path="url(#clip5_823_2791)">
        <path
          d="M137.522 166.921C141.908 166.921 145.464 163.365 145.464 158.979C145.464 154.593 141.908 151.037 137.522 151.037C133.136 151.037 129.58 154.593 129.58 158.979C129.58 163.365 133.136 166.921 137.522 166.921Z"
          fill="#DBD8D3" />
      </g>
      <g clip-path="url(#clip6_823_2791)">
        <path
          d="M75.5243 128.26L80.535 126.121L80.8319 126.816L75.8212 128.956L75.5243 128.26Z"
          fill="#020202" />
        <path
          d="M85.0004 127.509C86.0526 126.145 85.7956 124.218 84.4265 123.206C83.0573 122.193 81.0945 122.478 80.0424 123.843C78.9903 125.207 79.2473 127.133 80.6164 128.146C81.9855 129.158 83.9483 128.873 85.0004 127.509Z"
          fill="#939598" />
        <path
          d="M80.9876 125.816L83.654 124.63L84.0258 125.463L81.3593 126.65L80.9876 125.816Z"
          fill="#020202" />
      </g>
      <defs>
        <clipPath id="clip0_823_2791">
          <rect
            width="81.928"
            height="81.928"
            fill="white"
            transform="translate(223.491 374.807) rotate(-180)" />
        </clipPath>
        <clipPath id="clip1_823_2791">
          <rect
            width="171.38"
            height="262.225"
            fill="white"
            transform="translate(7.52399 112.581)" />
        </clipPath>
        <clipPath id="clip2_823_2791">
          <rect
            width="84.1575"
            height="126.236"
            fill="white"
            transform="translate(154.151 194.126) rotate(-119.092)" />
        </clipPath>
        <clipPath id="clip3_823_2791">
          <rect
            width="52.6676"
            height="281.732"
            fill="white"
            transform="translate(261.389 94.4678)" />
        </clipPath>
        <clipPath id="clip4_823_2791">
          <rect
            width="156.611"
            height="249.407"
            fill="white"
            transform="matrix(-0.839073 0.544019 0.544019 0.839073 276.808 23.7275)" />
        </clipPath>
        <clipPath id="clip5_823_2791">
          <rect width="15.884" height="15.884" fill="white" transform="translate(129.58 151.037)" />
        </clipPath>
        <clipPath id="clip6_823_2791">
          <rect
            width="10.5893"
            height="6.13067"
            fill="white"
            transform="translate(74.4647 125.75) rotate(-22.8883)" />
        </clipPath>
      </defs>
    </svg>
    <div style="text-align: center">
      <span class="text"> Coming Soon </span>
    </div>
  </div>
</div>
